import { useEffect, useState } from 'react';
import {
    first,
    getUrlSearchParams,
    includes,
    isNil,
    map,
    SuiteId,
    URL_PARAMETER
} from '@libs/shared';
import { SuiteUnreadStatus } from '../interfaces';
import { API } from '../../../constants';
import { getRequestUrl, post } from '../../../utils';

const useFetchSuiteUnreadStatus = (suiteId?: SuiteId) => {
    /**
     * 从url中的 _from 参数获取当前子产品类型
     * @see https://fanruan-x.feishu.cn/wiki/EPwOw3R4CiuxGAkE1GbcrdTqnUh#share-BmcEdsPAdo9RavxFTiPcPPG3nrc 4.1.1
     */
    const suiteIdParam = (() => {
        if (!isNil(suiteId)) {
            return suiteId;
        }
        const suiteIdParam = getUrlSearchParams(URL_PARAMETER._FROM);
        if (suiteIdParam) {
            return parseInt(suiteIdParam, 10);
        }
    })();
    // 因为链接中的携带的suiteId可能不是有效的，所以需要等 /suite/unread/list 再取有效的suiteId，增强健壮性
    const [currentSuiteId, setCurrentSuiteId] = useState<SuiteId>();
    const [suiteUnreadStatus, setSuiteUnreadStatus] = useState<SuiteUnreadStatus[]>();

    const switchCurrentSuite = (suiteId: SuiteId) => {
        setCurrentSuiteId(suiteId);
    };

    useEffect(() => {
        post<SuiteUnreadStatus[]>(getRequestUrl(API.message.suite_unread_list)).then((res) => {
            setSuiteUnreadStatus(res.data);
            /**
             * 如果query参数中的suiteId不在列表中，
             * 且不是平台页面（因为 /message_center/suite/unread/list 只返回子产品未读状态），
             * 则默认选中列表中第一个子产品
             */
            if (
                !includes(map(res.data, 'suite_id'), suiteIdParam) &&
                suiteIdParam !== SuiteId.PLATFORM
            ) {
                setCurrentSuiteId(first(res.data)?.suite_id);
            } else {
                setCurrentSuiteId(suiteIdParam);
            }
        });
    }, []);

    return {
        currentSuiteId,
        suiteUnreadStatus,
        isFetchingSuiteUnreadStatus: !suiteUnreadStatus,
        switchCurrentSuite
    };
};

export default useFetchSuiteUnreadStatus;
